import { faker } from '@faker-js/faker';
import type { GetRkiConfigurationByOrganizationIdV2QueryResponseApi } from '@ingenico/api-sdk-device-management-private-v2';
import { isEqual } from 'lodash-es';

export function getRkiConfigurationByOrganizationIdV2ResponseMock(method: string) {
  function innerFunction(): GetRkiConfigurationByOrganizationIdV2QueryResponseApi {
    return isEqual(method, 'PATCH')
      ? {
          environment: faker.commerce.department(),
          domain: faker.commerce.department(),
        }
      : {};
  }
  return innerFunction;
}
